/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const ordermadeSlider = () => {
		const splide = new Splide('.product-ordermade-style-slider.splide', {
			type: 'loop',
			perPage: 1.3,
			perMove: 1,
			autoplay: true,
			center: true,
			focus: 'center',
			gap: '8px',
			interval: 5000,
			speed: 500,
			clones: 4,
			gap: '20px',
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			focus: 'center',
			destroy: true,
			breakpoints: {
				1024: {
					destroy: false,
				},
			},
		}).mount();
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const ordermadeFUNCTIONS = () => {
		ordermadeSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { ordermadeFUNCTIONS(); }) : ordermadeFUNCTIONS();

})(window.FUNCTIONS);
